
$(document).ready(function () {

    var formId = $('.form').attr('id'); // $('form').attr('id');
    $('#' + formId).submit(function (event) {

          const submitButton = this.querySelector('[type="submit"]');
            submitButton.classList.remove('hidden');
      
        if (CodeApproved == false) {

          try {
            
             var sku = document.getElementById('product-sku').innerHTML;
          
            /*  
                Apply busy box to add to cart button to prevent double clicking and adding multiple items to cart - This no longer works !!
                The old website where this was working has since been converted to a newer shopify application.
            */

            //  const submitButton = this.querySelector('[type="submit"]');
            //  submitButton.setAttribute('aria-disabled', true);
            //  this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

              /* stop form from submitting normally */           
              event.preventDefault();

              var ocode = document.getElementsByName('properties[Org code]')[0].value;
              var acode = document.getElementsByName('properties[Design code]')[0].value;
              CodeValidationChecks(ocode, acode, sku);

            } catch (error) {
              /* stop form from submitting normally */           
              event.preventDefault();
          }

        }

    });
})


/*
$(document).ajaxStop(function() {
      alert('ajax stop');

      if(CodeApproved == true)
      {   
        alert('ajax - code approved');
        var formId = $('.form').attr('id');
        $('form#' + formId).submit();
        CodeApproved = false;
      }
      else
      {
        alert('ajax - code denied');
         const submitButton = this.querySelector('[type="submit"]');
         submitButton.classList.remove('loading');
         submitButton.removeAttribute('aria-disabled');
         this.querySelector('.loading-overlay__spinner').classList.add('hidden'); 
      }
})
*/

var CodeApproved = false;
function CodeValidationChecks(ocode, acode, psku) {

    return new Promise((resolve) => {
        $.ajax({
            url: "https://cfrdataservices.agcontroltower.com/validate.asmx/CompleteValidationCheckWithProductSku",
            data: "{'OrgCode': '" + ocode + "', 'ArtworkCode' : '" + acode + "', 'Sku' : '" + psku + "'}",
            dataType: "json",
            type: "POST",
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                $(data).each(function (index, data) {

                    if (data.d != '') {
                        if (data.d.IsValid == false) 
                        {
                          event.preventDefault();
                          alert(data.d.ErrorMessage);
                        }
                        else {
                            CodeApproved = true;
                            var formId = $('.form').attr('id');
                            $('form#' + formId).submit();
                        }
                    }
                });
            },

            error: function () { alert("No data found."); }

        });
    });
}
